export default "__VITE_ASSET__339e968d__"